<script lang="ts" setup>
import { useTresContext } from '@tresjs/core'

const { renderer } = useTresContext()
const { width } = useWindowSize()

renderer.value.setPixelRatio(
  width.value <= 768
    ? Math.min(window.devicePixelRatio, 1.5)
    : Math.min(window.devicePixelRatio, 1.5)
)
</script>
